import '../scss/list-models-catalog-vn.scss';

$(document).ready(function() {
  const filterItems = $('.makers-vn-energy_item[data-energy-filter]');
  const newModelRow = $('#newModelRow');
  const newModelSection = $('#newModelSection');

  filterItems.on('click', function() {

    if ($(this).hasClass('current')) {
      $(this).removeClass('current');
      $('.col-model').removeClass('d-none');
      if (newModelSection) {
        newModelSection.removeClass('d-none');
      }
      return;
    }

    const dataEnergy = $(this).data('energy-filter');

    $('.col-model').each(function() {
      if (!$(this).hasClass(dataEnergy)) {
        $(this).addClass('d-none');
      } else {
        $(this).removeClass('d-none');
      }
    })

    if (newModelRow) {
      const newModelItems = newModelRow.find('.col-model');
      let shouldHideNewModelSection = true;

      newModelItems.each(function() {
        if (!$(this).hasClass('d-none')) {
          shouldHideNewModelSection = false;
        }
      });

      if (shouldHideNewModelSection) {
        newModelSection.addClass('d-none');
      } else {
        newModelSection.removeClass('d-none');
      }
    }

    $('.makers-vn-energy_item').removeClass('current');
    $(this).addClass('current');

  })


});


// WEBPACK FOOTER //
// ./app/Resources/assets/group/js/list-models-catalog-vn.js